import React from 'react';
// Data
import { mainGalleryImagesArray } from '../../utils/data/GalleryData';
// Image
import LeftImage from '../../assets/images/main/gallery-left.jpeg';
import RightImage from '../../assets/images/main/mistress-diva-pro-dominatrix-and-femdom-stropon-in-the-mirrow.webp';

function MainGallerySection() {
  return (
    <section>
      <section className='relative grid'>
        {/* Left background image */}
        <div
          className='fixed top-0 left-0 w-1/2 h-full bg-cover bg-no-repeat z-10'
          style={{
            backgroundImage: `url(${LeftImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'top',
          }}
        ></div>

        {/* Right background image */}
        <div
          className='fixed top-0 right-0 w-1/2 h-full bg-cover bg-no-repeat z-10'
          style={{
            backgroundImage: `url(${RightImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'top',
          }}
        ></div>

        {/* Black filter overlay over both images */}
        <div className='absolute top-0 left-0 w-full h-full bg-black opacity-50 z-20'></div>

        {/* Content */}
        <div className='grid z-30 pt-80 lg:pt-[30rem]'>
          <section className='grid md:grid-cols-2 lg:grid-cols-3 gap-8 lg:container lg:mx-auto'>
            {mainGalleryImagesArray.map((image) => (
              <div key={image.src}>
                <div className={`lg:hidden overflow-hidden ${image.className}`}>
                  <img
                    src={image.src}
                    alt={image.alt}
                    aria-label={image.aria}
                    loading='lazy'
                    decoding='async'
                    className='w-full h-full object-cover'
                  />
                </div>
                <div className='hidden lg:inline-block overflow-hidden'>
                  <img
                    src={image.src}
                    alt={image.alt}
                    aria-label={image.aria}
                    loading='lazy'
                    decoding='async'
                    className='w-full h-full object-cover transition duration-[2s] hover:scale-125'
                  />
                </div>
              </div>
            ))}
          </section>
        </div>
      </section>
    </section>
  );
}

export default MainGallerySection;
